import { toRoman, percent } from "../helpers/formatting";
import { t } from "../helpers/localization";
import { BUILDING_TYPES, SHIP_CLASSES, NATIONS, buildingTypeModifierValue } from "../helpers/supply";

import { sendErrorNotification, sendNotification } from "./base";
import { wrapInP, getMessage, getMessageOfYouAreNotInClanNotification } from "./formatting";

export const sendNavyYardBonusActivated = modifier => {
  const message = wrapInP(modifier.title, t('Стоимость исследуемых кораблей %(level)s уровня снижена на %(costValuePercent)s для всех игроков клана с допуском.', {
    level: toRoman(modifier.ship_level),
    costValuePercent: percent(modifier.value, 0)
  }));
  sendNotification({
    hasHeader: true,
    header: t('Корпус построен:notification_header'),
    message,
    cost: modifier.cost,
    currency: 'clan_resource'
  });
};

export const sendDryDockBonusActivated = modifier => {
  const message = wrapInP(modifier.title, t('Стоимость обслуживания кораблей класса %(shipClass)s снижена на %(maintenanceValuePercent)s для всех игроков клана с допуском.', {
    shipClass: SHIP_CLASSES[`${modifier.ship_class}`.toLowerCase()],
    maintenanceValuePercent: percent(modifier.value, 0)
  }));
  sendNotification({
    hasHeader: true,
    header: t('Корпус построен:notification_header'),
    message,
    cost: modifier.cost,
    currency: 'clan_resource'
  });
};

export const sendEngineeringBonusActivated = modifier => {
  const message = wrapInP(modifier.title, t('Все игроки клана с допуском получают дополнительно %(extraExpPercent)s опыта за бой на кораблях нации: %(nation)s.', {
    extraExpPercent: percent(modifier.value, 0),
    nation: NATIONS[modifier.ship_nation]
  }));
  sendNotification({
    hasHeader: true,
    header: t('Корпус построен:notification_header'),
    message,
    cost: modifier.cost,
    currency: 'clan_resource'
  });
};

export const sendBarracksBonusActivated = modifier => {
  const message = wrapInP(modifier.title, t('Максимальное количество игроков в клане увеличилось на %(members)s.', {
    members: modifier.value
  }));
  sendNotification({
    hasHeader: true,
    header: t('Корпус построен:notification_header'),
    message,
    cost: modifier.cost,
    currency: 'clan_resource'
  });
};

export const sendMonumentCreatedNotification = modifier => {
  sendNotification({
    hasHeader: true,
    header: t('Ростральная колонна построена:notification_header'),
    message: t('Ростральная колонна символизирует успех и достижения вашего клана.'),
    cost: modifier.cost,
    currency: 'clan_resource'
  });
};

const SUPPLY_ERRORS = {
  insufficient_permissions: t('Недостаточно полномочий'),
  excluded_from_clan: ({
    clan
  }) => getMessageOfYouAreNotInClanNotification(clan),
  insufficient_funds: t('Недостаточно средств'),
  already_exists: t('Это строение уже возведено'),
  default: t('Техническая ошибка')
};
export const sendActivateBonusErrorNotification = (reason, {
  clan
}) => {
  sendErrorNotification({
    header: t('Не удалось возвести строение:notification_header'),
    message: getMessage(SUPPLY_ERRORS, reason, { clan })
  });
};

export const sendAccountBonusActivatedNotification = () => {
  const extraExp = buildingTypeModifierValue(BUILDING_TYPES.ENGINEERING);
  const costValue = buildingTypeModifierValue(BUILDING_TYPES.NAVY_YARD);
  const maintenanceValue = buildingTypeModifierValue(BUILDING_TYPES.DRY_DOCK);

  sendNotification({
    hasHeader: true,
    header: t('Допуск получен'),
    message: t('При наличии корпусов, вы можете получать дополнительно %(extraExpPercent)s опыта за бой, покупать исследуемые корабли по сниженной на %(costValuePercent)s стоимости и проводить их обслуживание по сниженной на %(maintenanceValuePercent)s стоимости.', {
      extraExpPercent: percent(extraExp, 0),
      costValuePercent: percent(costValue, 0),
      maintenanceValuePercent: percent(maintenanceValue, 0)
    })
  });
};